import { useGlobal } from '@/utils/useGlobal';

export default function IndexH5({ cards }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');
    return (
        <div className="containerH5">
            <div className="topBox">
                <p className="title">{t('dg200.cardsIconJ_title')}</p>
                <p className="desc">{t('dg200.cardsIconJ_desc')}</p>
            </div>
            <div className="bottomBox">
                {cards?.map((card: any, k: number) => (
                    <div className="card" key={k}>
                        <div className="cardIcon">{card?.icon}</div>
                        <p className="cardTitle">{card?.title}</p>
                        <p className="cardText">{card?.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
